import { $ } from './constants';

const MOBILE_BREAKPOINT = 950;
const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

export function updateResponsiveLinkTargets() {
    const isMobile = mediaQuery.matches;

    $('.js-responsive-link-target').each(function () {
        const $link = $(this);

        $link.attr('target', isMobile ? '_self' : '_blank');

        if (isMobile) {
            $link.attr('rel', 'noopener');
        } else {
            $link.attr('rel', 'noopener');
        }
    });
}

export function initResponsiveLinkTargets() {
    updateResponsiveLinkTargets();

    if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', updateResponsiveLinkTargets);
    } else {
        mediaQuery.addListener(updateResponsiveLinkTargets);
    }
}